import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export class CustomValidators {

  /**
   * Uses when two inputs in form group should have identical values (password confirmation for example)
   *
   * @param controlName
   * @param matchingControlName
   * @constructor
   */
  public static mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ must_match: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  /**
   * Uses for override error key that uses native validators
   *
   * Example changeKey('email_pattern', Validators.pattern(<email validation regexp>))
   *  result: {email_pattern: true}
   *
   * If you will just use Validators.pattern(<email validation regexp>)
   *  result should be: {pattern: true}
   *
   * @param newKey
   * @param validator
   */
  public static changeKey(newKey: string, validator: ValidatorFn): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const invalid = validator(control);

      if (invalid) {
        const validationResult = invalid[Object.keys(invalid)[0]];

        return {
          [newKey]: validationResult,
        };
      } else {
        return null;
      }
    };
  }

  /**
   * Is user eighteen or more years old
   *
   * @param control
   */
  // @ts-ignore
  public static eighteenYearsOld(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) {
      return null;
    }

    const [day, month, year] = control.value.split('/');
    if (!day && !month && !year) {
      return null;
    }
    const birthDate = new Date(year, month - 1, day);
    const currentDate = new Date();
    const diff = currentDate.getTime() - birthDate.getTime();
    const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));

    if (age < 18) {
      return { eighteen_years: true };
    } else {
      return null;
    }
  }

  public static validateYear(control: AbstractControl):
    { [key: string]: any } | null {
    if (control.value) {

      const yearValue = parseInt(control.value.split('/')[1], 10);
      const currentYear = new Date().getFullYear() % 100;

      if (yearValue < currentYear) {
        return { yearInPast: true };
      } else {
        return null;
      }

    }
  }
}
